import {Formik} from 'formik'
import Input from '../../../components/core/input'
import ButtonLoader from '../../../components/core/button/ButtonLoader'
import {SimpleBlueButton} from '../../../components/core/button'
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {updateChannel} from '../../../stores/customer-settings'
import {webhookURLSchema} from '../../../utils/validation'
import TextHelper, {trimStringValues} from './../../../utils/text'
import {toast} from 'react-toastify'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'

const UpdateWebhook = ({data, closePopup, webhooks, teamId}) => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const text = useNamespaceTranslations('notifications')
    const dispatch = useDispatch()

    const initialFormValues = {
        value: '',
        priority: data?.channel?.priority,
        type: data?.channel?.type
    }

    const updateNotificationChannel = async(values, {setFieldError}) => {
        if (webhooks.some(item => item.new_value === values.value)) {
            toast.error(text.webhook_already_used)
            return
        }
        setIsSubmitting(true)
        const success = await dispatch(updateChannel(true, teamId, trimStringValues(values), setFieldError))
        setIsSubmitting(false)
        if (success) {
            closePopup()
        }
    }

    return (
        <Formik initialValues={initialFormValues}
            enableReinitialize={true}
            onSubmit={updateNotificationChannel}
            validationSchema={webhookURLSchema}
            validateOnBlur={false}
            validateOnChange={false}>
            {({values, errors, handleSubmit, handleChange, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="modal-body">
                    <Input
                        type="url"
                        value={values.value}
                        placeholder={text.webhook}
                        name='value'
                        onChange={e => {
                            handleChange(e)
                            setFieldValue('value', TextHelper.getNormalizedUrl(e.target.value))
                        }}
                        infoText={text.webhook_input_info}
                        error={errors.value}
                    />
                    <SimpleBlueButton
                        type="submit"
                        disabled={isSubmitting}>
                        {isSubmitting && <ButtonLoader/>}
                        {text.update}
                    </SimpleBlueButton>
                </form>
            )}
        </Formik>
    )
}

export default UpdateWebhook
